import type { SVGProps } from 'react';
import { env } from '~/config/env';

const EXAM_NAME = env.VITE_APP === 'usmle' ? 'USMLE®' : 'EMS';

export function Logo(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="159"
      height="43"
      viewBox="0 0 159 43"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>MEDizzy {EXAM_NAME}</title>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M43.1846 15.2075H52.4135C53.063 15.2075 53.469 14.6911 53.469 14.066C53.469 13.3866 53.0901 12.8974 52.4135 12.8974H43.1846V7.27168C43.1846 6.61943 43.4553 6.32048 44.1048 6.32048H53.6314C54.335 6.32048 54.7139 5.80411 54.7139 5.12468C54.7139 4.44525 54.335 3.95605 53.6314 3.95605H43.4012C41.4796 3.95605 40.6406 4.79855 40.6406 6.8912V22.2192C40.6406 24.2847 41.4796 25.1272 43.4012 25.1272H53.8749C54.5786 25.1272 54.9575 24.5836 54.9575 23.9314C54.9575 23.2519 54.5786 22.7627 53.8749 22.7627H44.186C43.5906 22.7627 43.1846 22.5181 43.1846 21.8931V15.2075ZM58.1406 22.2192C58.1406 24.2847 58.9796 25.1272 60.9012 25.1272H65.7185C71.6456 25.1272 75.218 21.0777 75.218 14.3106C75.218 7.76088 71.6997 3.95605 65.7185 3.95605H60.9012C58.9796 3.95605 58.1406 4.79855 58.1406 6.8912V22.2192ZM60.7266 7.18982C60.7266 6.6191 61.1055 6.29297 61.6197 6.29297H65.6793C70.1448 6.29297 72.5535 9.14658 72.5535 14.3374C72.5535 19.637 69.9825 22.7624 65.5981 22.7624H61.5926C61.0513 22.7624 60.7266 22.4635 60.7266 21.8384V7.18982Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M78.5469 24.938H79.1346V3.87012H78.5469V24.938ZM80.7556 24.3478L95.4182 4.6668V3.87012H80.9907V4.46025H94.8305L80.168 24.1413V24.938H95.6532V24.3478H80.7556ZM95.4471 24.3478L110.11 4.6668V3.87012H95.6821V4.46025H109.522L94.8594 24.1413V24.938H110.345V24.3478H95.4471ZM118.008 15.4368L109.957 3.87012H109.223L117.714 16.0564V24.938H118.302V16.0564L126.794 3.87012H126.089L118.008 15.4368Z"
        fill="currentColor"
      />
      <path
        d="M15.1831 15.1336C15.6218 15.1336 16.01 14.8483 16.1427 14.4284L20.2859 1.31673L18.3538 1.27241L24.4559 24.1614C24.7152 25.1339 26.0764 25.1697 26.386 24.2121L32.2257 6.14788L30.3322 6.20823L33.5905 14.4634C33.7426 14.8488 34.1136 15.1018 34.5264 15.1018H43.1807C43.7367 15.1018 44.1874 14.6492 44.1874 14.0909C44.1874 13.5326 43.7367 13.0799 43.1807 13.0799H34.5264L35.4623 13.7184L32.204 5.46323C31.8564 4.58259 30.6018 4.62257 30.3106 5.52358L24.4709 23.5878L26.4009 23.6385L20.2988 0.749528C20.0386 -0.226396 18.671 -0.257774 18.3667 0.705199L14.2235 13.8169L15.1831 13.1117H1.00674C0.450733 13.1117 0 13.5643 0 14.1226C0 14.681 0.450733 15.1336 1.00674 15.1336H15.1831Z"
        fill="currentColor"
      />
      <text
        x={env.VITE_APP === 'usmle' ? '71%' : '68%'}
        y={40}
        dominantBaseline="middle"
        textAnchor="middle"
        fontSize={10}
        fontWeight={600}
        fill="currentColor"
        fontFamily="Nunito"
      >
        {EXAM_NAME} MASTERY
      </text>
    </svg>
  );
}
